import { render, staticRenderFns } from "./submittal-widget.vue?vue&type=template&id=4cfc06b2"
import script from "./submittal-widget.vue?vue&type=script&lang=js"
export * from "./submittal-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports